import React from 'react';
import classnames from 'classnames';
import { TThumbnail } from '../UploadingFileThumbnail.types';
import styles from '../UploadingFileThumbnail.scss';

export const Document: TThumbnail = ({ fallbackImageClassName }) => (
  <div className={classnames(styles.contentWrapper, styles.document)} data-hook="uploading-file-thumbnail-document">
    <div className={classnames(styles.content, fallbackImageClassName)} />
  </div>
);
